import React,{useEffect,useState} from 'react';
import bgHero from "../Assets/images/sectionfourbg.png"
import heroMobile from "../Assets/images/Mobile_06 1.png"
import android from "../Assets/images/android.png"
import apple from "../Assets/images/apple.png"

const SectionFour = () => {
    const [windowWidth, setWindowWidth] = useState(0);



    let resizeWindow = () => {
        setWindowWidth(window.screen.width);
    };

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    return(
        <div
            style={{
                backgroundImage: `url(${bgHero})`,
                backgroundSize: windowWidth < 500 ? '45%' : '25%',  // Ensures the image covers the entire div
                backgroundPosition: 'right 40%', // Centers the image
                backgroundRepeat: 'no-repeat', // Prevents tiling

            }}
            className="w-full flex ">
            <div className='flex flex-col lg:flex-row  lg:items-end justify-center lg:mx-auto lg:w-maxWidth w-full pt-18 pb-24  lg:pt-24 gap-10 lg:gap-0'>
                <div className="w-full  lg:w-2/4 flex items-center  justify-center ">
                    <img className=" w-2/4  md:w-2/6 lg:w-2/5 " src={heroMobile} alt={heroMobile} />
                </div>
                <div className="w-full lg:p-0  p-4  lg:w-2/4 flex flex-col gap-5 ">
                    <h2 className="font-roboto text-4xl font-light text-primary ">Quick & Easy <b className="font-bold">Registration</b></h2>
                    <p className=" font-roboto text-secondary text-lg">
                        Get registered in less than 30 seconds and get your business account verified online. The App allows you to link your bank account and guide you through the verification process, by easily uploading pictures of the required documents.
                    </p>

                </div>

            </div>
        </div>
    );
}

export  default SectionFour